export interface WPPost {
  id: number;
  slug: string;
  title: { rendered: string };
  excerpt: { rendered: string };
  content: { rendered: string };
  date: string;
  _embedded?: {
    "wp:featuredmedia"?: [{ source_url: string; alt_text: string }];
    "wp:term"?: [Array<{ name: string }>];
  };
}

const WP_API = "/wp-json/wp/v2";

export async function getPosts(count = 10): Promise<WPPost[]> {
  const res = await fetch(`${WP_API}/posts?_embed&per_page=${count}`);
  if (!res.ok) throw new Error("Falha ao buscar posts");
  return res.json();
}

export async function getPost(slug: string): Promise<WPPost> {
  const res = await fetch(`${WP_API}/posts?slug=${slug}&_embed`);
  if (!res.ok) throw new Error("Falha ao buscar post");
  const posts: WPPost[] = await res.json();
  if (!posts.length) throw new Error("Post não encontrado");
  return posts[0];
}

export function getPostCategory(post: WPPost): string {
  return post._embedded?.["wp:term"]?.[0]?.[0]?.name ?? "Artigo";
}

export function getFeaturedImage(post: WPPost): string {
  return post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? "";
}

export function calculateReadTime(content: string): string {
  const words = content.replace(/<[^>]*>/g, "").split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(words / 200));
  return `${minutes} min de leitura`;
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, "");
}
